export const getPrintTemplate = ({ headerInfo, details }) => {
  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");
  const rows = Array.isArray(details) ? details : [];

  const totals = {
    registeredQuantity: rows.reduce((a, b) => a + (Number(b.registeredQuantity) || 0), 0),
    actualQuantity: rows.reduce((a, b) => a + (Number(b.actualQuantity) || 0), 0),
    parValueTotal: rows.reduce((a, b) => a + (Number(b.parValueTotal) || 0), 0),
    totalAmount: rows.reduce((a, b) => a + (Number(b.totalAmount) || 0), 0),
  };

  return `
    <style>
      .print-ledger { font-family: "Times New Roman", Times, serif; color: #000; padding: 20px; }
      .header-table { width: 100%; margin-bottom: 10px; border-collapse: collapse; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .bold { font-weight: bold; }
      .italic { font-style: italic; }
      .title-box { margin: 15px 0; text-align: center; }
      .main-title { font-size: 18px; text-transform: uppercase; margin-bottom: 5px; }
      
      .data-table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 10px; }
      .data-table th, .data-table td { border: 1px solid #000; padding: 4px 2px; text-align: center; vertical-align: middle; }
      .data-table th { background-color: #f0f0f0; }
      
      .footer-info { margin-top: 15px; font-size: 11px; line-height: 1.6; }
      .footer-sign { display: flex; justify-content: space-between; margin-top: 25px; text-align: center; font-size: 11px; }
      .sign-col { width: 33%; }
      @media print { @page { size: landscape; margin: 0.5cm; } }
    </style>

    <div class="print-ledger">
      <table class="header-table">
        <tr>
          <td style="width: 45%; vertical-align: top;">
            <div class="bold">Đơn vị: ${headerInfo.unit || "........................"}</div>
            <div class="bold">Địa chỉ: ${headerInfo.address || "........................"}</div>
          </td>
          <td class="text-center" style="vertical-align: top;">
            <div class="bold">Mẫu số S43-DN</div>
            <div class="italic">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27/10/2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div class="title-box">
        <h1 class="main-title">SỔ CHI TIẾT PHÁT HÀNH CỔ PHIẾU</h1>
        <div class="bold">Năm: ${headerInfo.year || "...."}</div>
      </div>

      <div class="text-right italic" style="font-size: 11px;">Đơn vị tính: ${headerInfo.measurementUnit || "...."}</div>

      <table class="data-table">
        <thead>
          <tr>
            <th colspan="5">Đăng ký phát hành</th>
            <th colspan="7">Phát hành thực tế</th>
            <th colspan="2">Số cổ phiếu đã đăng ký phát hành nhưng chưa bán</th>
          </tr>
          <tr>
            <th colspan="2">Giấy phép phát hành</th>
            <th rowspan="2">Loại cổ phiếu</th>
            <th rowspan="2">Số lượng</th>
            <th rowspan="2">Mệnh giá</th>
            <th colspan="2">Chứng từ</th>
            <th rowspan="2">Loại cổ phiếu</th>
            <th rowspan="2">Số lượng</th>
            <th rowspan="2">Giá trị theo mệnh giá</th>
            <th rowspan="2">Giá thực tế phát hành</th>
            <th rowspan="2">Thành tiền</th>
            <th rowspan="2">Số lượng</th>
            <th rowspan="2">Mệnh giá</th>
          </tr>
          <tr>
            <th>Số hiệu</th>
            <th>Ngày tháng</th>
            <th>Số hiệu</th>
            <th>Ngày tháng</th>
          </tr>
          <tr style="background:#eee;">
            <th>A</th><th>B</th><th>C</th><th>1</th><th>2</th>
            <th>D</th><th>E</th><th>G</th><th>3</th><th>4</th><th>5</th><th>6</th>
            <th>7</th><th>8</th>
          </tr>
        </thead>
        <tbody>
          ${rows
      .map(
        (row) => `
            <tr>
              <td>${row.licenceNumber || ""}</td>
              <td>${row.licenceDate || ""}</td>
              <td>${row.registeredStockType || ""}</td>
              <td class="text-right">${fmt(row.registeredQuantity)}</td>
              <td class="text-right">${fmt(row.registeredParValue)}</td>
              <td>${row.documentNumber || ""}</td>
              <td>${row.documentDate || ""}</td>
              <td>${row.stockType || ""}</td>
              <td class="text-right">${fmt(row.actualQuantity)}</td>
              <td class="text-right">${fmt(row.parValueTotal)}</td>
              <td class="text-right">${fmt(row.actualIssuePrice)}</td>
              <td class="text-right">${fmt(row.totalAmount)}</td>
              <td class="text-right">${fmt(row.unsoldQuantity)}</td>
              <td class="text-right">${fmt(row.unsoldParValue)}</td>
            </tr>
          `
      )
      .join("")}
          <tr class="bold">
            <td colspan="3">Cộng</td>
            <td class="text-right">${fmt(totals.registeredQuantity)}</td>
            <td>x</td>
            <td>x</td>
            <td>x</td>
            <td>x</td>
            <td class="text-right">${fmt(totals.actualQuantity)}</td>
            <td class="text-right">${fmt(totals.parValueTotal)}</td>
            <td>x</td>
            <td class="text-right">${fmt(totals.totalAmount)}</td>
            <td>x</td>
            <td>x</td>
          </tr>
        </tbody>
      </table>

      <div class="footer-info">
        <div>- Sổ này có ${headerInfo.totalPages || "...."} trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: ${headerInfo.openingDate || "................"}</div>
      </div>

      <div class="footer-sign">
        <div class="sign-col">
          <div class="bold">Người ghi sổ</div>
          <div class="italic">(Ký, họ tên)</div>
          <div style="margin-top: 60px;" class="bold">${headerInfo.ledgerClerk || "........................"}</div>
        </div>
        <div class="sign-col">
          <div class="bold">Kế toán trưởng</div>
          <div class="italic">(Ký, họ tên)</div>
          <div style="margin-top: 60px;" class="bold">${headerInfo.chiefAccountant || "........................"}</div>
        </div>
        <div class="sign-col">
          <div class="italic">Ngày ${headerInfo.signingDay || "...."} tháng ${headerInfo.signingMonth || "...."} năm ${headerInfo.signingYear || "...."}</div>
          <div class="bold">Người đại diện theo pháp luật</div>
          <div class="italic">(Ký, họ tên, đóng dấu)</div>
          <div style="margin-top: 60px;" class="bold">${headerInfo.legalRepresentative || "........................"}</div>
        </div>
      </div>
    </div>
  `;
};
